"use strict";
/**
 * Weekly Report V2 Types
 *
 * Shared TypeScript types for the V2 weekly report pipeline.
 * Used by both backend (for generation) and frontend (for display).
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./constants"), exports);
__exportStar(require("./detailData"), exports);
__exportStar(require("./enums"), exports);
__exportStar(require("./evaluation"), exports);
__exportStar(require("./evaluationContext"), exports);
__exportStar(require("./hook"), exports);
__exportStar(require("./motion"), exports);
__exportStar(require("./report"), exports);
__exportStar(require("./sectionContent"), exports);
__exportStar(require("./skinThisWeek"), exports);
__exportStar(require("./template"), exports);
__exportStar(require("./treatmentEvaluation"), exports);
//# sourceMappingURL=index.js.map